import "./App.css";
import Main from "./Component/Main";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Privacy from "./Component/Privacy";
import ProductDetail from "./Component/ProductDetail";
import CartPage from "./Component/CartPage";
import CheckOut from "./Component/CheckOut";
import { CartProvider } from "./Component/CartContext";
import PaymentResult from "./Component/PaymentResult";
import Terms from "./Component/Terms";
import Shop from "./Component/Shop";
import Contact from "./Component/Contact";
import Returns from "./Component/Returns";
import About from "./Component/About";
import Header from "./Component/Header";
import Footer from "./Component/Footer";
import Delivery from "./Component/Delivery";
import PolicyHub, { policyLinks } from "./Policy/PolicyHub";
import DataRightsPolicy from "./Policy/DataRightsPolicy";
import CookiePolicy from "./Policy/CookiePolicy";
import DeliveryIssuesPolicy from "./Policy/DeliveryIssuesPolicy";
import CancellationPolicy from "./Policy/CancellationPolicy";
import InternationalPolicy from "./Policy/InternationalPolicy";
import PaymentsPolicy from "./Policy/PaymentsPolicy";
import PromotionsPolicy from "./Policy/PromotionsPolicy";
import SalePolicy from "./Policy/SalePolicy";
import ProductInformationPolicy from "./Policy/ProductInformationPolicy";
import CareSafetyPolicy from "./Policy/CareSafetyPolicy";
import ReviewsPolicy from "./Policy/ReviewsPolicy";
import IntellectualPropertyPolicy from "./Policy/IntellectualPropertyPolicy";
import AccessibilityPolicy from "./Policy/AccessibilityPolicy";
import PackagingPolicy from "./Policy/PackagingPolicy";
import ComplaintsPolicy from "./Policy/ComplaintsPolicy";
import PolicyUpdatesPolicy from "./Policy/PolicyUpdatesPolicy";
import PreOrderPolicy from "./Policy/PreOrderPolicy";
import FAQPolicy from "./Policy/FAQPolicy";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import siteConfig from "./config/siteConfig";
import productData from "./Datas/productData";

function RouteEffects() {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "auto" });
    const titles = {
      "/": `${siteConfig.displayName} | ${siteConfig.tagline}`,
      "/shop": `Shop | ${siteConfig.brandName}`,
      "/about": `Our story | ${siteConfig.brandName}`,
      "/contact": `Contact | ${siteConfig.brandName}`,
      "/cartpage": `Shopping bag | ${siteConfig.brandName}`,
      "/checkout": `Checkout | ${siteConfig.brandName}`,
      "/payment": `Payment status | ${siteConfig.displayName}`,
      "/paysuccess": `Payment status | ${siteConfig.displayName}`,
      "/privacy": `Privacy policy | ${siteConfig.brandName}`,
      "/terms": `Terms & conditions | ${siteConfig.brandName}`,
      "/returns": `Returns | ${siteConfig.brandName}`,
      "/shipping": `Shipping | ${siteConfig.brandName}`,
      "/policies": `Policy centre | ${siteConfig.displayName}`,
    };
    policyLinks.forEach(([label, path]) => {
      titles[path] = `${label} | ${siteConfig.displayName}`;
    });
    const productId = location.pathname.match(/^\/shopDetails\/(\d+)$/)?.[1];
    const product = productId ? productData.find((item) => item.id === Number(productId)) : null;
    document.title = product
      ? `${product.name} — ${product.colorName} | ${siteConfig.brandName}`
      : titles[location.pathname] || `${siteConfig.displayName} | Clothing`;
  }, [location.pathname, location.search]);

  return null;
}

function App() {
  return (
    <CartProvider>
      <Router future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
        <RouteEffects />
        <a className="skip-link" href="#main-content">Skip to content</a>
        <Header />
        <div id="main-content" tabIndex="-1">
          <Routes>
            <Route path="/about" element={<About />} />
            <Route path="/shipping" element={<Delivery />} />
            <Route path="/" element={<Main />} />
            <Route path="/returns" element={<Returns />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/shop" element={<Shop />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/shopDetails/:id" element={<ProductDetail />} />
            <Route path="/cartpage" element={<CartPage />} />
            <Route path="/checkout" element={<CheckOut />} />
            <Route path="/payment" element={<PaymentResult />} />
            <Route path="/paysuccess" element={<PaymentResult />} />
            <Route path="/policies" element={<PolicyHub />} />
            <Route path="/data-rights" element={<DataRightsPolicy />} />
            <Route path="/cookies" element={<CookiePolicy />} />
            <Route path="/delivery-issues" element={<DeliveryIssuesPolicy />} />
            <Route path="/cancellations" element={<CancellationPolicy />} />
            <Route path="/international-orders" element={<InternationalPolicy />} />
            <Route path="/payments" element={<PaymentsPolicy />} />
            <Route path="/promotions" element={<PromotionsPolicy />} />
            <Route path="/sale-items" element={<SalePolicy />} />
            <Route path="/product-information" element={<ProductInformationPolicy />} />
            <Route path="/care-safety" element={<CareSafetyPolicy />} />
            <Route path="/reviews-content" element={<ReviewsPolicy />} />
            <Route path="/intellectual-property" element={<IntellectualPropertyPolicy />} />
            <Route path="/accessibility" element={<AccessibilityPolicy />} />
            <Route path="/packaging" element={<PackagingPolicy />} />
            <Route path="/complaints" element={<ComplaintsPolicy />} />
            <Route path="/policy-updates" element={<PolicyUpdatesPolicy />} />
            <Route path="/pre-orders" element={<PreOrderPolicy />} />
            <Route path="/faq" element={<FAQPolicy />} />
          </Routes>
        </div>
        <Footer />
      </Router>
    </CartProvider>
  );
}

export default App;
